import { AxiosService } from './axios.service'
import { SearchService } from './search.service'

/**
 * Defines the API methods for a system configuration
 */
export class SystemConfigService extends SearchService {
	static baseURL = 'system'

	/**
	 * Gets the status PIX
	 * @return {bool} With pix status
	 */
	static getPixStatus() {
		return AxiosService.get(
			`${SystemConfigService.baseURL}/verificarPixStatus`
		).then(({ data }) => data)
	}

	/**
	 * Gets the status PIX and provider
	 * @return {Promise<PixConfigViewModel>} A promise that resolves with the list of routes.
	 */
	static getPixStatusAndProvider() {
		return AxiosService.get(
			`${SystemConfigService.baseURL}/verificarPixStatusAndProvider`
		).then(({ data }) => data)
	}


	/**
	 * Retrieves a list of routes where discounts are not allowed.
	 * Each route includes the origin city, origin state, destination city, and destination state.
	 *
	 * @return {Promise<List<ExceptionalDiscountRoute>>} A promise that resolves with the list of routes.
	 */
	static getRouteDoesNotAllowDiscountAsync() {
		return AxiosService.get(
			`${SystemConfigService.baseURL}/ObterRotaDeDescontoNaoPermitido`
		).then(({ data }) => data)
	}
}
